import { initials } from "@/lib/format";
import { cn } from "@/lib/utils";

type Props = {
  email: string;
  className?: string;
};

// Marks "you" on the side rail and in the mobile menu. Deliberately quiet —
// Page Wash fill, hairline ring, ink initial — so it never reads as the purple
// active-nav state sitting a few pixels above it. The email is the label; the
// initial is only a visual anchor, so it stays out of the accessibility tree.
const AccountAvatar = ({ email, className }: Props): JSX.Element => (
  <span
    aria-hidden="true"
    className={cn(
      "flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-semibold text-palomma-secondary ring-1 ring-border",
      className
    )}
  >
    {initials(email)}
  </span>
);

export default AccountAvatar;
